import { Component } from '@angular/core';

@Component({
  selector: 'app-counselling-dashboard-landing',
  templateUrl: './counselling-dashboard-landing.component.html',
  styleUrls: ['./counselling-dashboard-landing.component.scss']
})
export class CounsellingDashboardLandingComponent {

}
